export const labelStatus = ( status ) => {
  // const statusCombo = [
  //   { value: "ACCEPTED", label: "Aceptado" },
  //   { value: "ACTIVE", label: "Activo" },
  //   { value: "CANCELED", label: "Cancelado" },
  //   { value: "ROUTED", label: "En Ruta" },
  //   { value: "DONE", label: "Surtido" },
  // ];
  switch (status) {
    case 'ACCEPTED':
      return 'Aceptado'
    case 'ACTIVE':
      return 'Activo'
    case 'CANCELED':
      return 'Cancelado'
    case 'ROUTED':
      return  'En Ruta'
    case 'DONE':
      return 'Finalizado'
    default:
      return 'N/A'
  }
}